var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import DebugService from "./DebugService";
import { environment } from "../config/environment";
class PlacementApiService {
    constructor() { }
    static getInstance() {
        if (!PlacementApiService.instance) {
            PlacementApiService.instance = new PlacementApiService();
        }
        return PlacementApiService.instance;
    }
    /**
     * Gets the API URL dynamically from environment config
     */
    getApiUrl() {
        const url = environment.PLACEMENT_API_URL || "https://localhost:4001/api/placements";
        DebugService.debug("PlacementApiService API_URL:", url);
        return url;
    }
    /**
     * Gets the subscription key dynamically from environment config
     */
    getSubscriptionKey() {
        const key = environment.PLACEMENT_API_KEY || "";
        if (!key) {
            DebugService.warn("PlacementApiService: PLACEMENT_API_KEY is empty");
        }
        return key;
    }
    getAuthHeaders(apiToken) {
        return {
            "Ocp-Apim-Subscription-Key": this.getSubscriptionKey(),
            Authorization: `Bearer ${apiToken}`,
        };
    }
    sanitizeEMLFileName(input) {
        // Ensure input is a string and not empty
        if (!input || typeof input !== 'string') {
            DebugService.warn('sanitizeEMLFileName: Invalid input:', { input, type: typeof input });
            return "email";
        }
        // Lowercase
        let str = input.toLowerCase();
        // Replace invalid chars (anything not a-z, 0-9) with hyphen
        str = str.replace(/[^a-z0-9]/g, "-");
        // Replace multiple consecutive hyphens with single hyphen
        str = str.replace(/--+/g, "-");
        // Remove hyphen at start or end
        str = str.replace(/^-+/, "").replace(/-+$/, "");
        // Ensure starts with a letter (strip leading non-letters)
        str = str.replace(/^[^a-z]+/, "");
        // Ensure ends with a letter (strip trailing non-letters and digits)
        str = str.replace(/[^a-z]+$/, "");
        // If empty, default to "email"
        if (!str) {
            str = "email";
        }
        // Ensure length between 3 and 60
        if (str.length < 3) {
            str = str.padEnd(3, "a");
        }
        else if (str.length > 60) {
            str = str.substring(0, 60);
            // After trimming, re-strip trailing non-letters just in case
            str = str.replace(/[^a-z]+$/, "");
        }
        DebugService.debug("Original Subject:", input);
        DebugService.debug("Sanitize Subject:", str);
        return str;
    }
    submitPlacementRequest(apiToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                DebugService.placement("Starting placement request submission");
                DebugService.debug("EML content length:", data.emlContent.length);
                DebugService.debug("EML content preview:", data.emlContent.substring(0, 300) + "...");
                // Validate EML content before creating file
                if (!data.emlContent || data.emlContent.length === 0) {
                    throw new Error("EML content is empty");
                }
                if (!data.emlContent.includes("From:") ||
                    !data.emlContent.includes("Subject:")) {
                    throw new Error("EML content is missing required headers");
                }
                const emlBlob = new Blob([data.emlContent], { type: "message/rfc822" });
                const emlFile = new File([emlBlob], `${this.sanitizeEMLFileName(data.emailSubject) || "email"}.eml`, { type: "message/rfc822" });
                DebugService.debug("EML file size:", emlFile.size);
                DebugService.debug("EML file name:", emlFile.name);
                DebugService.debug("EML file type:", emlFile.type);
                const formData = new FormData();
                //formData.append("productCode", data.productCode);
                formData.append("lineOfBusiness", data.lineOfBusiness);
                formData.append("subLineOfBusiness", data.subLineOfBusiness);
                formData.append("emailSender", data.emailSender);
                formData.append("emailSubject", data.emailSubject);
                formData.append("emailReceivedDateTime", data.emailReceivedDateTime);
                formData.append("internetMessageId", data.internetMessageId);
                formData.append("mailbox", data.mailbox);
                formData.append("files", emlFile);
                formData.append("assignToMe", data.assignToMe);
                const headers = this.getAuthHeaders(apiToken);
                const apiUrl = this.getApiUrl();
                DebugService.api("POST", apiUrl, {
                    //productCode: data.productCode,
                    lineOfBusiness: data.lineOfBusiness,
                    subLineOfBusiness: data.subLineOfBusiness,
                    emailSubject: data.emailSubject,
                    emlFileSize: emlFile.size,
                });
                const response = yield fetch(apiUrl, {
                    method: "POST",
                    headers,
                    body: formData,
                });
                if (!response.ok) {
                    const error = yield response.json();
                    DebugService.error("Placement API failed", {
                        status: response.status,
                        error,
                    });
                    throw new Error(error.message || "Placement API call failed");
                }
                const result = yield response.json();
                DebugService.placement("Placement request submitted successfully", result);
                return result;
            }
            catch (error) {
                DebugService.errorWithStack("Placement API request failed", error);
                throw error;
            }
        });
    }
}
export default PlacementApiService.getInstance();
